module.exports = __webpack_public_path__ + "img/chervon-right.00e164de.svg";